import { useEffect, useState } from "react";
import { App } from "../App";

export const AppContainer = () => {
  const [canShow, setCanShow] = useState(false);

  useEffect(() => {
    setCanShow(true);
  }, []);

  if (!canShow) {
    return null;
  }

  return (
    <App />
  );
};
